import VideoConfigCard, {
  VideoConfigCardContainer,
  VideoConfigCardHeader
} from "@/pages/VideoClips/QuickCut/UIComponents/VideoConfigCard/VideoConfigCard";
import styles from './textdesc.module.less'
import {Button, Message, Modal, Switch} from '@arco-design/web-react';
import QuickStore from '@/stores/quickCutStore'
import { observer } from "mobx-react";
import { useState, useEffect } from "react";
import ChooseTextModal from '../../Components/ChooseText'
import QuickCutStore from '@/stores/quickCutStore'
import { getScriptRepoCountApi, getScriptRepoDetailsApi } from "@/services/quickcut";
import refeseImg from "@/assets/cut-mix-detail/refese.png";
const textDesc = (props) => {
  const { activeIndex } = props
  const { copy } = QuickStore.quickcutData.settings;
  const [visible, setVisible] = useState(false);
  const [total, setTotal] = useState(0);
  const [not_use_count, setUseCount] = useState(0);
  useEffect(() => {
    if (QuickStore.quickcutData.settings?.copy?.copy_id || QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.copy_id) {
      getScriptRepoCountApi({
        copy_id: QuickStore.quickcutData.settings?.copy?.copy_id || QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.copy_id
      }).then(res => {
        setTotal(res?.data?.total_count || 0)
        setUseCount(res?.data?.not_use_count || 0)
      })
      getScriptRepoDetailsApi({
        copy_id: QuickStore.quickcutData.settings.copy.copy_id || QuickCutStore.quickcutData.scenes[activeIndex]?.settings.copy.copy_id,
        status: 4,
        page: 1,
        page_size: 30
      }).then(res => {
        if (res.data?.items?.length > 0) {
          const textArr = res.data?.items.map(item => (item?.text || '')) || [];
          if (QuickStore.quickcutData.global) {
            QuickStore.previewTexts = textArr;
          } else {
            if (QuickCutStore.quickcutData.scenes[activeIndex].settings.copy.variable_name) {
              QuickCutStore.previewTexts = [QuickCutStore.quickcutData.scenes[activeIndex].settings.copy.variable_name]
            } else {
              QuickCutStore.previewTexts = textArr;
            }
          }
        }
      })
    }
  }, [QuickCutStore.quickcutData.settings?.copy?.copy_id, QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.copy_id]);
  const typeObj = {
    1: '组合文案',
    2: '智能文案',
    3: '爆款解说'
  }
  const showName = () => {
    if (QuickStore.quickcutData.global) {
      return `${typeObj[QuickCutStore.quickcutData?.settings.copy?.copy_type || 1]} / ${QuickCutStore.quickcutData?.settings?.copy?.copy_name || '-' }`
    } else {
      if (QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.copy_name) {
        return `${typeObj[QuickCutStore.quickcutData.scenes[activeIndex]?.settings.copy?.copy_type || 1]}
         / ${QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.copy_name} ${QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.variable_key ? '- ' + QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.variable_name : '' }`
      } else {
        return '-'
      }
    }
  }
  return (
    <div>
      <VideoConfigCard>
        <VideoConfigCardHeader
          headerLeft={
            <>
              <span>
                文案描述
              </span>
            </>
          }
          headerRight={
            <>
              <div className={'global-btn'}>
                <Button
                  className={'scene-btn'}
                  style={{marginLeft: 'auto'}}
                  onClick={() => {
                    Modal.confirm({
                      title: `切换${QuickStore.quickcutData.global ? '分镜配置' : '全局配置' }模式警告`,
                      content: QuickStore.quickcutData.global ? '切换到分镜配置模式,全局的文案描述将不会保留,是否继续?' : '切换到全局配置模式,分镜的文案描述将不会保留,是否继续?',
                      okText: '确认切换',
                      cancelText: '取消',
                      onOk: () => {
                        QuickStore.quickcutData.global = !QuickStore.quickcutData.global;
                        Message.success(`已切换到${QuickStore.quickcutData.global ? '全局配置' : '分镜配置'}`);
                        if (!QuickStore.quickcutData.global) {
                          QuickStore.quickcutData.settings.copy.copy_id = null
                          QuickStore.quickcutData.settings.copy.copy_name = ''
                          QuickStore.quickcutData.settings.copy.copy_type = null
                        } else {
                          QuickStore.quickcutData.scenes.forEach(item => {
                            item.settings.copy.copy_id = null
                            item.settings.copy.copy_name = ''
                            item.settings.copy.copy_type = null
                            item.settings.general.mode = 'follow_audio'
                            item.duration = 0
                          })
                        }
                      }
                    });
                  }}
                  icon={
                    <img
                      src={refeseImg}
                      style={{
                        width: 16,
                        height: 16,
                        marginRight: 4,
                        position: "relative",
                        top: "3px",
                      }}
                    />
                  }
                  size="small">
                  <span style={{color: '#333333'}}>{QuickStore.quickcutData.global ? '全局配置' : '分镜配置'}</span>
                </Button>
              </div>
            </>
          }></VideoConfigCardHeader>
        <VideoConfigCardContainer style={{height: 'auto'}}>
          <div className={styles['text-desc']}>
            <div>已选择：{showName()}</div>
            {
              not_use_count > 0 && <div className={styles['text-total']}>可用条数：{not_use_count}/{total}</div>
            }
          </div>
          {
            QuickCutStore.quickcutData.parse_name && <div className={styles['text-desc']}>
                  <div>已选择：脚本库 / {QuickCutStore.quickcutData.parse_name}</div>
              </div>
          }
          <div className={'flex--between--center'}>
            <div onClick={() => {
              setVisible(true);
            }} className={styles['text-title']}>
              <div className={styles['text-btn']}>引用文案库</div>
            </div>
            <div className={styles['text-switch'] + ' flex--center'}>
              字幕: <Switch onChange={(e) => {
              copy.show_subtitle = e;
            }} checked={copy.show_subtitle} style={{marginLeft: 5}} size={'small'}></Switch>
            </div>
          </div>
        </VideoConfigCardContainer>
      </VideoConfigCard>
      <ChooseTextModal closeHot={false} onShowHot={!QuickCutStore.quickcutData.global} activeIndex={activeIndex} emitChange={(item, id, variableObj) => {
        if (QuickCutStore.quickcutData.global) {
          QuickCutStore.quickcutData.settings.copy.copy_id = id
          QuickCutStore.quickcutData.settings.copy.copy_name = item.name;
          QuickCutStore.quickcutData.settings.copy.copy_type = Number(item.type);
        } else {
          QuickCutStore.quickcutData.scenes[activeIndex].settings.copy.copy_id = id
          QuickCutStore.quickcutData.scenes[activeIndex].settings.copy.copy_name = item.name
          QuickCutStore.quickcutData.scenes[activeIndex].settings.copy.copy_type = Number(item.type)
          if (variableObj) {
            console.log(variableObj, 'variableObj')
            QuickCutStore.quickcutData.scenes[activeIndex].settings.copy.variable_key = variableObj.key
            QuickCutStore.quickcutData.scenes[activeIndex].settings.copy.variable_name = variableObj.title
          }
        }
        setVisible(false);
      }} handCancel={() => {
        setVisible(false);
      }} visible={visible} />
    </div>
  )
}
export default observer(textDesc);
